module.exports = __webpack_public_path__ + "img/back_length_to_waist.fc7bc990.png";